import React, {  useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import messages from './BusinessOperationsComponent.messages'
import metadata from './BusinessOperationsComponent.metadata.json5';
import styles from "../DirectorsAndOfficers.module.scss"
import { useTranslator } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function BusinessOperationsComponent(props) {

const { submissionVM, updateWizardData,pathUpdated} = props;
const breakpoint = useContext(BreakpointTrackerContext);
const { onValidate } = useValidation('BusinessOperationsComponent');
const modelVM = _.get(submissionVM, pathUpdated)
const translator = useTranslator()

modelVM.value.isValidationReq = true;
modelVM.value.country = 'CA';
modelVM.value.baseState = _.get(submissionVM.value, 'baseData.baseState_Ext')


 const calTotalNumOfEmp = useCallback(() =>{
    const numofEmpUnion = _.get(modelVM, 'numOfEmpUni22.value') !== null ? _.get(modelVM, 'numOfEmpUni22.value'):0
    const numofEmpNonUnion = _.get(modelVM, 'numOfEmpNon23.value') !== null ? _.get(modelVM, 'numOfEmpNon23.value'): 0
    const totalEmp = numofEmpUnion + numofEmpNonUnion

    _.set(modelVM, 'totNumOfEmp24.value', totalEmp) 
 },[modelVM]);

// eslint-disable-next-line react-hooks/exhaustive-deps
  const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        ifYesIncUndTheLawOf5: {
            visible: _.get(modelVM, 'isOrgInc4.value', false)
        },
        datInc6: {
            visible: _.get(modelVM, 'isOrgInc4.value', false)
        },
        ifYesDes10: {
            visible: _.get(modelVM, 'actOutOfCan9.value', false)
        },
        ifYesDes12: {
            visible: _.get(modelVM, 'doYouConAnyOpeAwaFro11.value', false)
        },
        ifNoPleProDet17: {
            visible: _.get(modelVM, 'theComOrOrgHasPubRep16.value') !== undefined &&  !_.get(modelVM, 'theComOrOrgHasPubRep16.value')
        },
        ifYesPleProFulDet19: {
            visible: _.get(modelVM, 'areTheAnyPlaOrIntFor18.value', false)
        },
        doeTheOrgEngInAnyOf13: {
            label: translator(messages.doeTheOrgEngInAnyOf13)
        },
        additionalInfoContainer: {
            visible: true
        },
        havYouAnyPerLinHoyHavFre: {
            visible: _.get(submissionVM.value, 'baseData.baseState_Ext') === 'QC'
        },
        ifYesProDet: {
            visible: !_.isUndefined(_.get(modelVM, 'hasInsRefVoiCan.value')) &&  _.get(modelVM, 'hasInsRefVoiCan.value')
        }
    };


const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles,
    };

const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM,pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM,`${fullPath}`,value);

            if(changedPath === 'numOfEmpUni22' || changedPath === 'numOfEmpNon23'){
                calTotalNumOfEmp()
            }

            updateWizardData(submissionVM);         
        },
        [calTotalNumOfEmp, pathUpdated, submissionVM, updateWizardData]
    );

return (
            <ViewModelForm
                uiProps={metadata.componentContent}
                model={modelVM}
                //onModelChange={updateWizardData}
                resolveValue={readValue}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                onValueChange={handleValueChange}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
    );


}

BusinessOperationsComponent.propTypes = wizardProps;
export default withRouter(BusinessOperationsComponent);
